import React from "react";
import PropTypes from "prop-types";

// material-ui components
import withStyles from "material-ui/styles/withStyles";
import Card from "material-ui/Card";
import CardContent from "material-ui/Card/CardContent";
import CardHeader from "material-ui/Card/CardHeader";
import CardActions from "material-ui/Card/CardActions";
import Typography from "material-ui/Typography";
import Avatar from "material-ui/Avatar";
import GridContainer from "components/Grid/GridContainer.jsx";
import ItemGrid from "components/Grid/ItemGrid.jsx";

import newStatsCardStyle from "assets/jss/material-dashboard-pro-react/components/newStatsCardStyle.jsx";

function NewStatsCard({ ...props }) {
  const {
    classes,
    title,
    description,
    statLink,
    small,
    statText,
    statIconColor,
    iconColor,
    statNum
  } = props;
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <GridContainer direction="row" justify="flex-start">
          <ItemGrid>
            <Avatar classes={{root: classes.cardAvatar + " " + classes[iconColor + "CardHeader"]}}>
              <props.icon />  
            </Avatar>
          </ItemGrid>
          <ItemGrid style={{ flex: 1 }}>
            <Typography
              variant="headline"
              component="h1"
              className={classes.cardTitle}
            >
              {statNum}
            </Typography>
            <Typography
              className={classes.cardTitleSmall}
            >
              {title}
            </Typography>
          </ItemGrid>
        </GridContainer>
      </CardContent>
    </Card>
  );
}

NewStatsCard.defaultProps = {
  iconColor: "purple",
  statIconColor: "gray"
};

NewStatsCard.propTypes = {
  classes: PropTypes.object.isRequired,
  icon: PropTypes.func.isRequired,
  iconColor: PropTypes.oneOf(["orange", "green", "red", "blue", "purple"]),
  title: PropTypes.node,
  description: PropTypes.node,
  small: PropTypes.node,
  statIconColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  statLink: PropTypes.object,
  statText: PropTypes.node
};

export default withStyles(newStatsCardStyle)(NewStatsCard);



// WEBPACK FOOTER //
// ./src/components/Cards/NewStatsCard.jsx